'use client';

import type {SxProps, Theme} from '@mui/material/styles';
import {styled} from '@mui/material/styles';
import {forwardRef, type HTMLAttributes, type ReactNode} from 'react';
import {Typography} from './Typography';

export interface StatusTagProps extends HTMLAttributes<HTMLSpanElement> {
  icon?: ReactNode;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

const StatusTagRoot = styled('span')(({theme}) => {
  const colors = theme.palette.colors;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(0.75),
    borderRadius: theme.radii.sm,
    border: `1px solid ${colors.border.neutral.strong}`,
    color: colors.text.neutral.default,
    whiteSpace: 'nowrap',
    '& svg': {fontSize: 16, color: colors.icon.primary.default},
  };
});

export const StatusTag = forwardRef<HTMLSpanElement, StatusTagProps>(({icon, children, ...rest}, ref) => (
  <StatusTagRoot ref={ref} {...rest}>
    {icon}
    <Typography
      as="span"
      family="primary"
      size="body-3"
      weight="medium"
      textTransform="uppercase"
      sx={{color: 'inherit', letterSpacing: '-0.015em'}}
    >
      {children}
    </Typography>
  </StatusTagRoot>
));

StatusTag.displayName = 'StatusTag';
